module.exports = __webpack_public_path__ + "static/media/gulp-logo.eb44f759.svg";


//////////////////
// WEBPACK FOOTER
// ./src/gulp-logo.svg
// module id = 51
// module chunks = 0